/**
 * Created by richard on 7/14/14.
 */
var CSnotesModel = angular.module('CSnotesModel', ['schoolModel']);
CSnotesModel.factory('CSNotesModelFactory', function(ApplicationService, RestService, authServiceFactory, SchoolModelFactory, AbstractModelService){
    var CSNotesModel = function(){
        this.endpoint = "/CSnotes";
        this.primaryKey = "recordID";
    }
    CSNotesModel.prototype = new SchoolModelFactory();
    CSNotesModel.prototype.parent = SchoolModelFactory.prototype;
    
    CSNotesModel.prototype.new = function()
    {
        var schoolID = this.getSchoolID();
        var t = new Date();
        var flag = {schoolID: schoolID, user: '', note: '', timestamp: t, deleted:0}; 
        return flag;
    }
    
    return CSNotesModel;
});


CSnotesModel.service('CSNotesModelService', function(CSNotesModelFactory){
    var CSnotesModel = new CSNotesModelFactory();
    return CSnotesModel;
});


